import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.5028 17.9832L4.17059 5.38864H17.6383L18.3061 17.9832H3.5028Z",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.30029 7.93L7.30029 4.37045C7.30029 3.48242 7.68 2.63076 8.35589 2.00283C9.03177 1.37489 9.94847 1.02213 10.9043 1.02213C11.8602 1.02213 12.7769 1.37489 13.4527 2.00283C14.1286 2.63076 14.5083 3.48242 14.5083 4.37045V7.93",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }